<template>
    <!-- 电池仓 -->
    <div class="batteryCom">
      <div
        class="margin-top-sm"
        v-for="(item, index) in batteryHolder"
        :key="index"
      >
      <div class="battery-color flex flex-direction justify-center align-center " :class="{'battery-100':item.status*1===3,'battery-grey':item.status==1||item.status==5,'battery-red':!item.temperature||item.status*1===0||item.status*1===4}" @click="clickSIngleBattery(item,index)">
        <div :class="{'select':item.batteryId==curBatteryId}">
          <div class="diamond"></div>
        </div>
        <div class="flex justify-center align-center">
          <!-- 1-待机；2-充电；3-充电完成；0和4-故障；5- 离线 -->
          <div v-show="item.status*1===2||!item.temperature" class="batteryIcon" :class="{'red':!item.temperature}"></div>
          <div v-show="item.status*1===1" class="batteryIcon grey"></div>
          <div v-show="item.status*1===5" class="batteryIcon error"></div>
          <div class="text-xss batteryNum">
            {{item.currentSoc}}<span class="text-10">%</span>
          </div>
        </div>
        <div class="text-10">
          NO.{{item.positionNo}}<span v-show="!item.temperature">(温度告警)</span>
        </div>
      </div>
          
      </div>
    </div>
</template>
<script>
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data() {
    return {
      batteryHolder:[],
      curSingleIndex:0,//当前选中电池下标,定义新的变量，防止修改父组件
      curBatteryId:'',//当前电池id
    };
  },
  components: {},
  props: {
    selectBattery:{
      type:Number,
      default:0
    },
    // batteryList: {
    //   type: Array,
    //   default: () => ([])
    // },
  },
  watch: {
    selectBattery(newValue, oldValue) {  
        this.curSingleIndex = newValue;
    } 
  },
  mounted() {
    this.curBatteryId = this.$route.query&&this.$route.query.batteryId;
    console.log('curBatteryId',this.curBatteryId)
  },
  methods: {
    getData(data) {
      this.selectStationBatteryHolder(data);
    },
    selectStationBatteryHolder(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'chongdiancang-TiDB',
          '@station_id':data.stationId,
        })
        .then((res) => {
          if(!res) return;
          _this.batteryHolder = res.map(item =>{
            return {
              ...item,
              temperature:item.temperature>60?false:true
            }
          })
          res.map((item,index) => {
            if(this.curBatteryId ==item.batteryId){
              this.curSingleIndex = index;
            }
          })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击单个电池
    clickSIngleBattery(item,index){
      if(index!=this.curSingleIndex){
        this.curSingleIndex = index;
        this.$emit("changeParentIndex",index);
        this.$router.replace({
            path:window.location.href.indexOf('pcbatteryHolder')>-1? '/pcbatteryHolder':'/batteryHolder',
            query: {
              batteryId:item.batteryId,
              stationId: this.$route.query.stationId,
              chargeWarehouseId:this.$route.query.chargingWarehouseNumber
            }
          })
          // if(window.location.href.indexOf('batteryHolder')>-1){
          //   //TODO:暂时方案，刷新页面
          //   this.$router.go(0);
          // }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.batteryCom {
  margin-top:100px;
  display: grid;
  grid-template-columns: repeat(4, 150px);
  grid-template-rows: repeat(2, 46px);
  grid-row-gap: 60px;
  grid-column-gap: 30px;
  justify-content:center;
  max-height:200px;
  overflow-y: scroll;
}
.battery-color {
  width: 150px;
  height: 46px;
  background: url('~@/assets/images/site/battery_green_light.png') no-repeat;
  background-size: 140px 46px;
  position: relative;
  .select{
    width: 160px;
    height:60px;
    left:-10px;
    border-radius: 6px;
    position: absolute;
    border: 2px solid rgba(79, 236, 242, 0.76);
    background: linear-gradient(180deg, rgba(13, 21, 25, 0) 0%, rgba(1, 177, 169, 0.46) 100%);
    .diamond{
      width:28px;
      height:33px;
      position: absolute;
      background: url('~@/assets/images/battery/battery_select.png') no-repeat;
      background-size:28px 33px;
      top:-70%;
      left:45%;
      // transform:translateX(-50%)；
    }
  }
}
.battery-100 {
  background: url('~@/assets/images/site/battery_green.png') no-repeat;
  background-size: 140px 46px;
}
.battery-red {
  background: url('~@/assets/images/site/battery_red.png') no-repeat;
  background-size: 140px 46px;
}
.battery-grey {
  background: url('~@/assets/images/site/battery_grey.png') no-repeat;
  background-size: 140px 46px;
}
.batteryIcon {
  width: 12px;
  height: 16px;
  background: url('../../assets/images/site/light-blue.png') no-repeat;
  background-size: 12px 16px;
  &.red{
    background: url('../../assets/images/site/light-red.png') no-repeat;
    background-size: 12px 16px;
  }
  &.grey{
    background: url('../../assets/images/site/light-white.png') no-repeat;
    background-size: 12px 16px;
  }
  &.error{
    background: url('../../assets/images/site/light-error.png') no-repeat;
    background-size: 12px 16px;
  }
}
.batteryNum {
  line-height: 10px;
}
</style>
